// Query keys for the Program entity — one source so invalidation stays in sync.

export const PROGRAM_KEYS = {
  all: ['program'] as const,
  enrolled: () => [...PROGRAM_KEYS.all, 'enrolled'] as const,
  byId: (id: string | number) => [...PROGRAM_KEYS.all, 'byId', String(id)] as const,
} as const;
